import { useEffect } from 'react'
import { Loader } from '@calendly/ui/components/loader'

import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'
import EmbedAnalytics from 'services/analytics/embed'
import { useLandingPage } from 'components/use_landing_page'
import ErrorAlert from 'components/error/alert'
import { useSendSegmentEvent } from 'hooks/use-segment-events'

import { LandingPage } from './landing_page'

const LandingPageDetails = ({ landingPage }) => {
  const sendSegmentEvent = useSendSegmentEvent()

  // Do not merge the following useEffects into one, as sendSegmentEvent is called several times
  useEffect(() => {
    sendSegmentEvent(
      'event_types_catalog',
      { id: landingPage.owning_user.id, uuid: landingPage.owning_user.uuid },
      landingPage.id,
      'event_types_catalog'
    )
  }, [landingPage, sendSegmentEvent])

  useEffect(() => {
    GoogleAnalytics.userTrackEvent('invitee_visits_landing_page', `${landingPage.name}-${landingPage.uuid}`)
    FbPixel.trackCustom('invitee_visits_landing_page', `${landingPage.name}-${landingPage.uuid}`)
    EmbedAnalytics.track('landing_page_viewed')
  }, [landingPage])

  return (
    <LandingPage landingPage={landingPage} />
  )
}

export const LandingPagePage = () => {
  const landingPage = useLandingPage()

  if (landingPage === undefined) {
    return <Loader />
  }

  if (landingPage === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  return (
    <LandingPageDetails landingPage={landingPage} />
  )
}
